module.exports = __webpack_public_path__ + "static/media/drag.172dd5d6.svg";